// DHL-Fehler lesbar anzeigen; Roh-Antwort von DHL aufklappbar.
export function ShipmentError({ error, details, testid }) {
  if (!error) return null;
  return (
    <div className="text-xs text-rose-700 mt-1 max-w-md whitespace-normal break-words" data-testid={testid}>
      {error.split("; ").map((line, i) => <div key={i}>{line}</div>)}
      {details && (
        <details className="mt-1 text-slate-500">
          <summary className="cursor-pointer hover:text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded" data-testid={testid ? `${testid}-details` : undefined}>Details (DHL-Antwort)</summary>
          <pre className="mt-1 p-2 bg-slate-50 border border-slate-200 rounded text-[10px] whitespace-pre-wrap break-all max-h-48 overflow-auto">{details}</pre>
        </details>
      )}
    </div>
  );
}
